package dev.lingvo.site.components.studio.canvas

import dev.lingvo.shared.screenshots.render.ImageHandle

/** Owns an ImageBitmap until the compose pipeline releases it; dynamic bridges DOM bindings absent in this build. */
class BitmapImage(override val key: String, internal val bitmap: dynamic) : ImageHandle {
    override val width: Int = (bitmap.width as Number).toInt()
    override val height: Int = (bitmap.height as Number).toInt()
    private var closed = false

    /** Idempotent release lets failure cleanup share the normal bitmap ownership path. */
    fun close() {
        if (!closed) {
            bitmap.close()
            closed = true
        }
    }
}
